<div class="card mb-3 bg-2">
  <div class="card-body">
    <div class="col-md-12 col-lg-6">
      <label>Importação de arquivo.</label>
      <div class="row uploadfilecontainer" [class.uploadfilecontainer-disabled]="readOnly" appDragDrop
           (onFileDropped)="uploadFile($event)">
        <div class="col-1" (click)="fileInput.click()">
          <button type="button" class="btn btn-default" title="Anexar arquivo">
            <i class="fas fa-file-upload fa-2x" aria-hidden="true"></i>
          </button>
        </div>
        <div class="col-10" (click)="fileInput.click()">
          <span class="mt-1 ml-2 label-maps label-anexos">{{currentFileName}}</span>
          <input type="file" #fileInput (change)="uploadFile($event.target.files)" style="display: none"
                 [disabled]="readOnly" [accept]="'.xls, .xlsx, .zip'">
        </div>
        <div class="col-1 pl-0" *ngIf="currentFileName !== INPUT_MESSAGE">
          <button type="button" class="btn btn-default" (click)="resetFile()">
            <i class="material-icons">close</i>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="card-footer clearfix">
    <div class="container-fluid">
      <div class="row justify-content-end">
        <div class="pr-3">
          <button mat-raised-button title="Baixar Modelo Importação Lote" (click)="downloadModelo()"
                  aria-label="left">
            Baixar modelo
          </button>
        </div>
        <div>
          <button mat-raised-button color="primary"
                  [disabled]="!showExecutar || !isFileSelected() || semPermissaoExecutar"
                  class="container btn-gravar" type="submit" title="{{nameButtonProcess()}}" (click)="importar()"
                  aria-label="left">
            <loading-icon [btnLabel]="'Executar'" [loading]="isLoading"></loading-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<form autocomplete="off" [formGroup]="formPesquisa" (ngSubmit)="pesquisar(this.formPesquisa.value)">
  <div class="card bg-2">
    <div class="card-body">
      <label>Histórico de importações</label>
      <div class="row mt-2 pesquisa">
        <div class="col-sm-6 col-md-3 col-lg-3 col-xl-2 data-inicio-container">
          <lib-datepicker-day [schema]="dataInicioSchema"></lib-datepicker-day>
        </div>
        <div class="col-sm-6 col-md-3 col-lg-3 col-xl-2 data-fim-container">
          <lib-datepicker-day
            [schema]="dataFimSchema"
          ></lib-datepicker-day>
        </div>
        <div class="col-sm-12 col-md-9 col-lg-4 col-xl-5 usuario-container">
          <mat-form-field class="w-100" appearance="outline">
            <mat-label>Usuário</mat-label>
            <input matInput type="text" formControlName="usuario">
          </mat-form-field>
        </div>
        <div class="col-sm-6 col-md-3 col-lg-2 col-xl-3 status-container">
          <mat-form-field class="w-100" appearance="outline">
            <mat-label>Status</mat-label>
            <mat-select formControlName="status">
              <mat-option *ngFor="let tipo of [{},{id: 'ENVIADO_AUTORIZACAO', name:'Enviado para autorização'}, {id: 'FALHA', name: 'Falha na importação'},
              {id: 'SUCESSO', name: 'Autorizado'}, {id: 'REJEITADO', name: 'Rejeitado'}]"
                          [value]="tipo.id">
                {{tipo.name}} </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="card-footer clearfix">
      <div class="container-fluid">
        <div class="row justify-content-end">
          <div>
            <button mat-raised-button color="primary"
                    [disabled]="formPesquisa.invalid || isLoading || semPermissaoListar"
                    type="submit" title="Pesquisar" aria-label="left">
              <loading-icon [btnLabel]="'Pesquisar'" [loading]="isLoading"></loading-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>

<div class="card">
  <div class="card-body bg-2">
    <table class="table label-maps table-maps table-striped table-hover table-bordered table-responsive-md">
      <thead>
      <tr>
        <th scope="col">Nome do arquivo</th>
        <th scope="col">Data/Hora início</th>
        <th scope="col">Data/Hora fim</th>
        <th scope="col">Usuário</th>
        <th scope="col">Progresso</th>
        <th scope="col">Status</th>
        <th scope="col" class="text-center">Ações</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let l of logs" [ngClass]="{'falha-color':l.status === 'FALHA'}">
        <td>{{l.fileName}}</td>
        <td>{{l.inicio  | date: 'dd/MM/yyyy HH:mm:ss'}}</td>
        <td>{{l.fim  | date: 'dd/MM/yyyy HH:mm:ss'}}</td>
        <td>{{l.usuario}}</td>
        <td>{{l.progresso}}</td>
        <td>{{parseStatus(l.status)}}</td>
        <td class="d-flex justify-content-center">
          <button type="button" class="btn btn-default ml-1" (click)="downloadXlsxCompleto(l)"
                  title="Download completo da planilha">
            <i class="fas fa-cloud-download-alt"></i>
          </button>
          <button *ngIf="l.status === 'FALHA'" type="button" class="btn btn-default ml-1"
                  (click)="dowloadStack(l)" title="Download Erro">
            <i class="fas fa-exclamation-circle"></i>
          </button>
        </td>
      </tr>
      </tbody>
    </table>
    <div class="row d-flex justify-content-center">
      <maps-pagination [items]="paginationTotalPage" [pageNumber]="page$" (pageSend)="receiverPage($event)"></maps-pagination>
    </div>
  </div>
</div>

